<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<style>
	.album-thumbnails {
		/* set the desired width/height and margin here */
		width: 110px;
		margin-right: 12px;

		position: relative;
		overflow: hidden;
		display: inline-block;
	}
	.album-thumbnails img {
		/* position: absolute;
		left: 50%;
		top: 50%;
		height:auto;
		max-width: 90px;
		-webkit-transform: translate(-50%,-50%);
			-ms-transform: translate(-50%,-50%);
				 transform: translate(-50%,-50%); */
	}
</style>
<template>
	<div class="marketplace grey-page billing-panel">
		<section class="container-white marketplace-container">
			<h3 class="page__main-title">Supplier Marketplace</h3>
			<!-- Header -->
			<!-- Header -->
			<div class="marketplace-header mdc-layout-grid">
				<div class="mdc-layout-grid__inner">
					<div class="marketplace-header__balance-wrapper mdc-layout-grid__cell mdc-layout-grid__cell--span-5 mdc-layout-grid__cell--span-12-tablet">
						<a href="#" @click.prevent="$router.push('/billing-panel')" class="marketplace-header__balance-text">My Total Subscriptions:</a><span class="marketplace-header__balance">£{{priceWithComma(balance)}}pm</span>
					</div>
					<div class="marketplace-header__search mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-12-tablet mdc-textfield-container">
						<div class="mdc-textfield mdc-textfield--fullwidth mdc-text-field--dense mdc-textfield--with-trailing-icon mdc-ripple-upgraded">
							<input id="search" class="mdc-textfield__input marketplace-header__search-input" type="text" placeholder="Search..." v-model="search"/>
							<i class="mdc-textfield__icon ico ico-search"></i>
					  </div>
					</div>
				</div>
			</div>

			<div class="marketplace-header__filters mdc-layout-grid">

				<div class="mdc-layout-grid__inner">
					<!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-12-tablet">
						<input type="checkbox" id="paid" v-model="filtered_extra['paid']">
						<label for="paid">Paid</label>
				  </div> -->
				  <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-12-tablet">
					  <input type="checkbox" id="free" v-model="filtered_extra['free']">
					  <label for="free">Free</label>
				 </div>
				 <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-12-tablet">
					 <input type="checkbox" id="subscribed" v-model="filtered_extra['subscribed']">
					 <label for="subscribed">Subscribed</label>
				</div> -->


				<!-- <div class="mdc-switch">
				  <div class="mdc-switch__track"></div>
				  <div class="mdc-switch__thumb-underlay">
				    <div class="mdc-switch__thumb">
				        <input type="checkbox" id="paid" class="mdc-switch__native-control" role="switch" v-model="filtered_extra['paid']">
				    </div>
				  </div>
				</div>
				<label for="paid">Paid</label> -->

					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-12-tablet">
					</div>

					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-9 mdc-layout-grid__cell--span-12-tablet">

						<label for="paid" class="mdc-switch-label">Paid</label>
						<div class="mdc-switch">
						  <input id="paid" v-model="filtered_extra['paid']" type="checkbox" class="mdc-switch__native-control" />
						  <div class="mdc-switch__background">
						    <div class="mdc-switch__knob"></div>
						  </div>
						</div>

						<label for="free" class="mdc-switch-label">Free</label>

						<div class="mdc-switch">
						  <input id="free" v-model="filtered_extra['free']" type="checkbox" class="mdc-switch__native-control" />
						  <div class="mdc-switch__background">
						    <div class="mdc-switch__knob"></div>
						  </div>
						</div>

						<label class="mdc-switch-label" for="subscribed">Subscribed</label>
						<div class="mdc-switch">
						  <input id="subscribed" v-model="filtered_extra['subscribed']" type="checkbox" class="mdc-switch__native-control" />
						  <div class="mdc-switch__background">
							 <div class="mdc-switch__knob"></div>
						  </div>
						</div>
					</div>
				</div>
				<!--
					<div class="mdc-layout-grid__inner" v-if="Object.keys(categories).length > 0">
						<div v-for="(item, index) in Object.keys(categories)" :key="index" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-12-tablet">
							<input type="checkbox" :id="index" v-model="filtered_categories[item]">
							<label :for="index">{{ categories[item] }}</label>
					  </div>
					</div>
				-->
			</div>
			<!-- List -->
			<div class="marketplace-list">
				<div v-for="cat in Object.keys(categories)" class="marketplace-list__section">
					<div class="marketplace-list__header" v-show="counter[cat] > 0">
					  <h3>{{ categories[cat] }}</h3>
				  </div>
				  <service-row v-for="(item, key) in filtereditems" :ref="item.itemId+'-row'" :key="key" v-if="item.category == cat && item.active === 'Yes'" :title="item.title" :icon="((!item.img || item.img == '') && item.icon) ? item.icon : ''" :logo="item.img ? s3url(item.img, 'small') : ''" :price="parseInt(item.price)" :description="item.description" :itemdata="item"></service-row>
			  </div>

			</div>

			<aside class="mdc-dialog billing-panel__payment-method__dialog text-left" :class="{'mdc-dialog--open': paymentMethodDialog}" role="alertdialog" aria-hidden="true" aria-labelledby="mdc-dialog-default-label" aria-describedby="mdc-dialog-default-description">
				<div class="mdc-button mdc-button--raised btn--spinner button btn-spin--visible" v-show="loadingcard === true"></div>
				<div class="mdc-dialog__surface" v-show="loadingcard === false">
					<header class="mdc-dialog__header mdc-layout-grid__inner billing-panel__payment-method__dialog-header">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 text-right billing-panel__payment-method__dialog-close">
							<a @click.prevent="paymentMethodDialog = false; manualCharge;" class="mdc-dialog__footer__button--cancel"><i class="ico ico-delete"></i></a>
						</div>
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 text-center billing-panel__payment-method__dialog-title">
							<h3 class="">Payment Method</h3>
						</div>
					</header>
					<section class="mdc-dialog__body mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
							<!-- Payment Options  -->
							<div class="mdc-layout-grid__inner billing-panel__payment-method__dialog-options">
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 billing-panel__payment-method__dialog-option" @click.prevent="isPayPal = false" :class="{'billing-panel__payment-method__dialog-option--selected': !isPayPal}">
									<i class="ico ico-bank_card"></i>
									<h3>Credit/Debit Card</h3>
								</div>
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 divider-title mq-sm-show" style="display: none;"><span>Or</span></div>
								<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 billing-panel__payment-method__dialog-option" @click.prevent="isPayPal = true" :class="{'billing-panel__payment-method__dialog-option--selected': isPayPal}" style="display: none;">
									<i class="pf pf-paypal-alt"></i>
									<h3>PayPal</h3>
								</div>
								<span class="triangle-up" :class="{'triangle-up--paypal': isPayPal}"></span>
							</div>

							<!-- Card Details Form -->
							<div class="billing-panel__payment-method__dialog-form">
								<form action="http://127.0.0.1/charge" method="post" id="payment-form" >

								  <div class="form-row">
									  <div class="text-updating-card" v-if="hascard === true">
										You are updating your card that already exists.
										<!--
											<button type="button" @click.prevent="manualCharge">Pay now</button> <button type="button" @click.prevent="updateCard">Update Card</button>
										-->
									  </div>
									  <div id="card-errors" role="alert">
										 <span v-if="errorcard.error === true" class="is-danger" v-html="errorcard.msg"></span>
										 <span v-else class="text-success" v-html="errorcard.msg"></span>
										</div>
									 <!-- <label for="card-element" v-show="hascard === false">
										Credit/Debit Card
									 </label> -->
									 <div id="card-element">
										<!-- A Stripe Element will be inserted here. -->
										<div class="field">

											<span class="brand"><i class="pf pf-credit-card" id="brand-icon"></i></span>
											<div id="card-element-card-number"></div>
											<label for="card-element-card-number">Card Number</label>
										</div>
										<div class="field half-width">
											<div id="card-element-card-expiry">
											</div>
											<label for="card-element-card-expiry">Expiration Date</label>
										</div>
										<div class="field half-width card-cvc">
											<div id="card-element-card-cvc">
											</div>
											<label for="card-element-card-cvc">CVC Code</label>
										</div>
									 </div>
									 <!-- Used to display form errors. -->
									 <!-- <button v-if="hascard === false">Save card</button> -->
									</div>
									<!-- <div v-if="hascard === true">
										<button type="button" @click.prevent="manualCharge">Pay now</button> <button type="button" @click.prevent="updateCard">Update Card</button>
									</div> -->
									<footer class="mdc-dialog__footer mdc-layout-grid__inner billing-panel__payment-method__dialog-footer">
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-9 billing-panel__payment-method__dialog-conditions text-right">
											<p>I have read and agreed with the <a href="#">Terms & Conditions.</a></p>
										</div>
										<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-3-tablet text-right">
											<button type="button" @click.prevent="updateCard" class="mdc-button mdc-button--raised billing-panel__payment-method__dialog-save-btn">Save</button>
										</div>
									</footer>
								</form>
							</div>

						</div>
					</section>

				</div>
			</aside>
		</section>
	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import ServiceRow from '../components/ServiceRow.vue';


var cardNumber, cardExpiry, cardCvc, stripe, elements;
export default {
	data: function() {
		return {
			balance: 0,
			rebalance: 0,
			billday: 0,
			tests_startDate: 0,
			filtered_categories: {
				"applicant": true,
				"properties": true,
				"website": true,
				"sales": true,
				"crm": true,
				"other": true
			},
			filtered_extra: {
				"free": true,
				"paid": true,
				"subscribed": true
			},
			now: new Date(),
			monthnow: new Date(),
			monthlast: new Date(),
			counter: {
				"applicant": 0,
				"properties": 0,
				"website": 0,
				"sales": 0,
				"crm": 0,
				"other": 0
			},
			categories: {
				"applicant": "Applicant Management",
				"properties": "Properties",
				"website": "My BestAgent Website",
				"sales": "Sales Progression",
				"crm": "CRMs",
				"other": "All Other Services",
				"outra": "Outra coisa"
			},
			defaultExtradata: { category: "other", icon: "ico-archive"},
			search: '',
			active: [],
			services: [],
			items: [],
			filtereditems: [],
			manualCharge: false,
	  		errorcard: "",
	  		cards: [],
	  		default_card: "",
	  		hascard: false,
	  		loadingcard: false,
  		 	paymentMethodDialog: false,
  		 	isPayPal: false,
			pendingItem: ''
		}
	},
	mixins: [utils],
	created: async function() {
		const that = this;
		const getinfo = await api({endpoint: this.config.services.payments, path: '/', method: 'GET'});
		if (getinfo.tests_startDate) {
			this.tests_startDate = parseInt(getinfo.tests_startDate);
			this.now = await this.Datex(this.tests_startDate);
			let dtnow = this.now;
			let dtlast = this.now;
			this.monthnow = new Date(dtnow.setMonth(this.now.getMonth()));
			this.monthlast = new Date(dtnow.setMonth(this.now.getMonth() - 1));
		}
		if (getinfo.cards && getinfo.cards.cards && getinfo.cards.cards.length !== 0) {
		  this.hascard = true;
		}
		await this.recalculate();
		this.filtereditems = await this.filteredList();
	},
	components: {
		'service-row': ServiceRow
	},
	watch: {
		filtereditems: {
		   async handler(val){
				await this.recountFiltered(this.filtereditems);
			},
		  deep: true
		},
		search: async function() {
			this.filtereditems = await this.filteredList();
		},
		filtered_extra: {
	     async handler(val){
			  this.filtereditems = await this.filteredList();
	     },
	     deep: true
		}
	},
	computed: {
	},
	async mounted() {
    setTimeout(function() {
  		stripe = Stripe(process.env.BA_STRIPEKEY);
  		elements = stripe.elements();
    },2000);
   },
	methods: {
    priceWithComma(price,decimals) {
			var splitPrice = price;
			if (typeof price != 'string') {
				splitPrice = splitPrice.toString();
			}

			if (splitPrice.indexOf(',') !== -1) {
				let resplitPrice = splitPrice.match(/\d+\,\d+/)[0];
				let rere = resplitPrice;
				rere = rere.replace(',','.');
				splitPrice = splitPrice.replace(resplitPrice,rere)
			}

			if (decimals) {
				splitPrice = parseFloat(splitPrice).toFixed(decimals);
			}

      	return splitPrice;
		},
		async recountFiltered(from) {
			let rethis = this;
			let recounter = {};
			await Promise.all(from.map(itm => {
				if (!recounter[itm.category])
					recounter[itm.category] = 0;
				if (itm.active && itm.active == 'Yes')
					recounter[itm.category]++;
			}));
			this.counter = recounter;
		},
		async filteredList() {
			const rethis = this;
			let refilter = rethis.items;
			let refilter_paid;
			let refilter_free;
			if (rethis.search != '') {
				refilter = refilter.filter(post => {
					return post.title.toLowerCase().includes(rethis.search.toLowerCase());
				});
			} else {
				refilter = refilter.filter(post => {
					if (rethis.filtered_extra['free'] === true && rethis.filtered_extra['paid'] === true) {
						return true;
					} else if (rethis.filtered_extra['paid'] === true) {
						return parseFloat(post.price) !== 0;
					} else {
						return !post.price || parseFloat(post.price) === 0;
					}
				});

				refilter = refilter.filter(post => {
					if (rethis.filtered_extra['free'] === true && rethis.filtered_extra['paid'] === true) {
						return true;
					} else if (rethis.filtered_extra['free'] === true) {
						return !post.price || parseInt(post.price).toFixed(0) == '0';
					} else {
						return parseInt(post.price).toFixed(0) != '0';
					}
				});
				if (rethis.filtered_extra['free'] === false && rethis.filtered_extra['paid'] === false) {
					refilter = rethis.items.filter(post => {
						if (rethis.filtered_extra['subscribed'] === false) {
							return !post.isactive || post.isactive === false;
						} else {
							return post.isactive && post.isactive === true;
						}
					});

				} else {
					refilter = refilter.filter(post => {
						if (rethis.filtered_extra['subscribed'] === false) {
							return !post.isactive || post.isactive === false;
						} else {
							return true;
						}
					});
				}
			}

			await this.recountFiltered(refilter);
			return refilter;
	   },
		async cardAddedNowPay() {
			if (this.pendingItem != '' && this.$refs[this.pendingItem+'-row']) {
				this.$refs[this.pendingItem+'-row'][0].activate()
				this.pendingItem = '';
			}
		},
		async sendCard() {
			let that = this;
			this.loadingcard = true;
			this.hascard = false;
			this.errorcard = { error: false, msg: "" };
			stripe.createToken(cardNumber).then( async function(result) {
			 if (result.error) {
				// Inform the user if there was an error.
				that.errorcard = { error: true, msg: result.error.message };
				that.loadingcard = false;
			 } else {
				// Send the token to your server.
				if (result.token && result.token.card) {
					const tokencard = result.token.id;
					const newcard = await api({endpoint: that.config.services.payments, path: '/set-card/'+tokencard, method: 'GET'});
					if (newcard && newcard.return === true) {
						that.cards[0] = result.token.card;
						that.cards[0].cvc_check = 'pass';
						that.hascard = true;
						that.errorcard = {error: false, msg: "Your card is now active, your bills will be automatically charged every recurring month."};
						that.loadingcard = false;
						that.paymentMethodDialog = false;
						that.cardAddedNowPay();
					} else {
						that.loadingcard = false;
						that.paymentMethodDialog = false;
						that.errorcard = {error: true, msg: "Something went wrong adding your card, please try again, another one, or contact BestAgent team."};
					}
				} else {
					that.loadingcard = false;
					that.paymentMethodDialog = false;
					that.errorcard = {error: true, msg: "Please contact BestAgent team or try again later." };
				}
			 }
			});
		},
		async updateCard() {
			if (this.hascard === true && confirm("Are you sure you want to update your card? the previous one will become forgotten.")) {
				await this.sendCard();
			} else if (this.hascard === false) {
				await this.sendCard();
			}
		},
		async Datex(startDate) {
			// Return default date
			if (startDate === undefined || startDate === null || startDate === 0)
				return new Date();

			// Get the fake date
			if (typeof startDate == 'object')
			   startDate = startDate.getTime();
			else
			   startDate = new Date(startDate).getTime();

			const oneHourNormalMs = 1 * 60 * 60 * 1000;
			const oneHourFastMs = 24 * oneHourNormalMs;

			const oneMsFast = oneHourFastMs / oneHourNormalMs;

			const nowx = new Date().getTime();
			const diffx = Math.abs(nowx - startDate);
			const returnx = new Date(startDate + (diffx * oneMsFast));
		  	return returnx;
		},
		async recalculate() {
			const servdata = await api({endpoint: this.config.services.billing, path: '/billingitems', method: 'GET'});
			if (!isNaN(servdata.balance)) {
				this.balance = Math.abs(parseFloat(servdata.balance));
				this.rebalance = 0;
				this.billday = servdata.rdate;
				this.monthnow.setDate(parseInt(servdata.rdate)+1);
				this.monthlast.setDate(parseInt(servdata.rdate));
				this.services = [];
				this.services = servdata.services;
				this.items = [];
				let rethis = this;

				await Promise.all(Object.keys(this.services).map(serv => {
					let obj = rethis.services[serv];

					if (obj.title) {
						if (!obj.category || obj.category == '')
							obj.category = rethis.defaultExtradata['category'];
						if (!obj.icon || obj.icon == '')
							obj.icon = rethis.defaultExtradata['icon'];
					}

					if (obj.isactive && obj.active && obj.active == 'Yes') {
						if (obj.type == 'Recurring') {
							if (obj.frequency == 'Minute')
								rethis.rebalance += ((parseFloat(obj.price) * 60) * 24) * 30;
							else if (obj.frequency == 'Hourly')
								rethis.rebalance += (parseFloat(obj.price) * 24) * 30;
							else if (obj.frequency == 'Daily')
								rethis.rebalance += parseFloat(obj.price) * 30;
							else if (obj.frequency == 'Weekly')
								rethis.rebalance += parseFloat(obj.price) * 4;
							else if (obj.frequency == 'Monthly')
								rethis.rebalance += parseFloat(obj.price);
							else if (obj.frequency == 'Quarterly')
								rethis.rebalance += parseFloat(obj.price) / 3;
							else if (obj.frequency == 'Yearly')
								rethis.rebalance += parseFloat(obj.price) / 12;
						} else {
							//rethis.rebalance += parseFloat(obj.price) * obj.lasttrack.quantity;
						}
					}

					if (obj.active && obj.active == 'Yes')
						rethis.items.push(obj);
				}));
            this.items.sort((a, b) => a.index - b.index);
				this.balance = parseFloat(this.rebalance).toFixed(2);
			}
		},
		setupCard() {

			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
				base: {
					color: '#424F65',
					lineHeight: '18px',
					fontFamily: '"Muli", sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '16px',
					'::placeholder': {
						color: '#D1D1D1',
					},
					':-webkit-autofill': {
						color: '#FFCCA5',
					},
				},
				invalid: {
					color: '#bf4336',
					iconColor: '#bf4336'
				}
			};

			let that = this;

			 // Floating labels
			  var inputs = document.querySelectorAll('#payment-form .InputElement');
			  Array.prototype.forEach.call(inputs, function(input) {
				  input.addEventListener('focus', function() {
					  input.classList.add('focused');
				  });
				  input.addEventListener('blur', function() {
					  input.classList.remove('focused');
				  });
				  input.addEventListener('keyup', function() {
					  if (input.value.length === 0) {
						  input.classList.add('empty');
					  } else {
						  input.classList.remove('empty');
					  }
				  });
			  });

			  var elementClasses = {
				 focus: 'focused',
				 empty: 'empty',
				 invalid: 'invalid',
			  };
			 // Create an instance of the card Element.
			if (!cardNumber) {
				 cardNumber = elements.create('cardNumber', {
					style: style,
					classes: elementClasses,
					placeholder: ''
				 });
			 }
			 cardNumber.mount('#card-element-card-number');

			 if (!cardExpiry) {
				 cardExpiry = elements.create('cardExpiry', {
					style: style,
					classes: elementClasses,
					placeholder: 'MM/YY'
				 });
			 }
			 cardExpiry.mount('#card-element-card-expiry');
			 if (!cardCvc) {
				 cardCvc = elements.create('cardCvc', {
					style: style,
					classes: elementClasses,
					placeholder: ''
				 });
			 }
			 cardCvc.mount('#card-element-card-cvc');

			 // registerElements([cardNumber, cardExpiry, cardCvc], 'card-element');

			// Add an instance of the card Element into the `card-element` <div>.
			// card.mount('#card-element');
			// Handle real-time validation errors from the card Element.
			cardNumber.addEventListener('change', function(event) {
			  var displayError = document.getElementById('card-errors');
			  if (event.brand) {
				 that.setBrandIcon(event.brand);
			  }
			  if (event.error) {
				 that.errorcard = {error: true, msg: event.error.message };
			  } else {
				 that.errorcard = {error: false, msg: '' };
			  }
			});
		},
		async setBrandIcon(brand) {
			var cardBrandToPfClass = {
			 'visa': 'pf-visa',
			  'mastercard': 'pf-mastercard',
			  'amex': 'pf-american-express',
			  'discover': 'pf-discover',
			  'diners': 'pf-diners',
			  'jcb': 'pf-jcb',
			  'unknown': 'pf-credit-card',
		  };
		   var brandIconElement = document.getElementById('brand-icon');
		   var pfClass = 'pf-credit-card';
		   if (brand in cardBrandToPfClass) {
		 	 pfClass = cardBrandToPfClass[brand];
		   }
		   for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
		 	 brandIconElement.classList.remove(brandIconElement.classList[i]);
		   }
		   brandIconElement.classList.add('pf');
		   brandIconElement.classList.add(pfClass);
	   },
		populateSubscriptions() {
			let rethis = this;
			this.tracks.forEach(item => {
				if (item.item.type === 'Recurring') {
					rethis.subscriptions.push(item.item);
				}
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Marketplace.vue